import React from 'react';
import {Card, CardBody, CardHeader, ListGroup, ListGroupItem,} from 'reactstrap';
import ElementCardActions from './ElementCardActions';

const HeaderCard = (props) => {
  // ----------------------
  // Methods
  // ----------------------

  function onAction(key) {
    switch (key) {
      case 'delete':
        return props.onDelete();
      case 'edit':
        return props.onEdit();
      case 'moveDown':
        return props.onMoveDown();
      case 'moveUp':
        return props.onMoveUp();
      default:
        throw new Error('Invalid action key');
    }
  }

  // ----------------------
  // Render
  // ----------------------

  return (
    <Card className="mb-3">
      <CardHeader className="card-header--with-actions">
        <span> <i className="fa fa-header"/>  Header </span>
        {props.canEdit &&
          <ElementCardActions
            actions={props.actions}
            onAction={key => onAction(key)}
            showActions
          />
        }
      </CardHeader>
      <CardBody>
        <ListGroup className="list-group-flush">
          <ListGroupItem>

            <div style={{whiteSpace: 'pre-line', unicodeBidi: 'embed', maxWidth: '100%'}}>{props.element.content}</div>
          </ListGroupItem>
        </ListGroup>
      </CardBody>
    </Card>
  );
};

export default HeaderCard;
